import React, { useEffect, useRef } from "react";
import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import useEmulationMode from "utilities/contexts/emulation/use-emulation-mode";

const END_CLASS = "c-emulation-mode-banner__end";

interface EndEmulationSessionButtonProps {
    disabled?: boolean;
}

const EndEmulationSessionButton = ({
    disabled = false,
}: EndEmulationSessionButtonProps) => {
    const { token, endEmulationMode } = useEmulationMode();

    const endSessionText = "End Session";

    const timeoutId = useRef<number>();
    const countDownToExpiration = (expiresOn: string | undefined) => {
        if (expiresOn !== undefined) {
            const expiresOnTime = Date.parse(expiresOn);
            const countdownMilliseconds = expiresOnTime - Date.now();
            return countdownMilliseconds;
        }
    };

    useEffect(() => {
        if (token?.id != null) {
            clearTimeout(timeoutId.current);
            const id = setTimeout(async () => {
                console.log(
                    "*************CALLING END EMULATION SESSION VIA useEffect, clearTimeout.",
                    token?.id
                );
                await endEmulationMode(token?.guestId);
            }, countDownToExpiration(token?.expiresOn));
            timeoutId.current = id;
        }

        return () => clearTimeout(timeoutId.current);
    }, []); // empty deps

    const handleEndSession = () => {
        if (token?.id != null && token.guestId != null) {
            endEmulationMode(token.guestId);
        }
    };

    return (
        <Button
            disabled={disabled}
            cssClassName={END_CLASS}
            onClick={handleEndSession}
            style={ButtonStyles.Destructive}>
            {endSessionText}
        </Button>
    );
};

export default EndEmulationSessionButton;
